$(function () {
  $('.js-fancy-img').fancybox({
    afterLoad : function(instance, current) {
      let pixelRatio = window.devicePixelRatio || 1;

      if ( pixelRatio > 1.5 ) {
        current.width  = current.width  / pixelRatio;
        current.height = current.height / pixelRatio;
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/fancybox.js